<template>
    <b-container fluid style="margin-top: 60px">
        <h1 v-on:click="flipClosed">
            {{ title }} &nbsp;
            <b-button>
                {{ btnTekst }}
            </b-button>
        </h1>
        <b-row>
            <b-col sm="12">
                <div v-if="showFilter">
                    <b-row no-gutters>
                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_filter', { ns: 'common' })"
                                label-for="filter-input"
                                label-cols-sm="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                        id="filter-input"
                                        v-model="filter"
                                        type="search"
                                        :placeholder="
                                            $t('com_typetosearch', {
                                                ns: 'common'
                                            })
                                        "
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button
                                            :disabled="!filter"
                                            @click="filter = ''"
                                            >{{
                                                $t('com_wis', { ns: 'common' })
                                            }}</b-button
                                        >
                                    </b-input-group-append>
                                </b-input-group>

                                <b-button
                                    v-if="checkRight('RecipeCreate')"
                                    :disabled="gesloten"
                                    size="sm"
                                    @click="createNewItem"
                                    class="mr-1"
                                    ><font-awesome-icon
                                        icon="folder-plus"
                                        size="1x"
                                    />
                                    {{ strNieuw }}
                                </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_perpagina', { ns: 'common' })"
                                label-for="per-page-select"
                                label-cols-sm="6"
                                label-cols-md="4"
                                label-cols-lg="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-button
                        v-if="checkRight('RecipeCreate')"
                        :disabled="gesloten"
                        size="sm"
                        @click="createNewItem"
                        class="mr-1"
                        ><font-awesome-icon icon="folder-plus" size="1x" />
                        {{ strNieuw }}
                    </b-button>
                </div>

                <b-table
                    :items="displayList"
                    :fields="visibleFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    stacked="md"
                    show-empty
                    :empty-text="$t('com_geen_data', { ns: 'common' })"
                    small
                    striped
                    @filtered="onFiltered"
                    @row-clicked="toonDetails"
                >
                    <template v-slot:cell(actions)="row">
                        <b-button
                            size="sm"
                            v-if="magBewerken"
                            @click="editItem(row.item)"
                            :disabled="gesloten"
                            class="bgc_aux_warning"
                            ><font-awesome-icon icon="edit" size="1x" />
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="checkRight('RecipeClose')"
                            @click="verwijderItem(row.item)"
                            :disabled="gesloten"
                            class="bgc_aux_alarm"
                            ><font-awesome-icon icon="trash-alt" size="1x" />
                        </b-button>
                        <b-button
                            size="sm"
                            @click="toonDetails(row.item)"
                            class="bgc_aux_unknown"
                            ><font-awesome-icon icon="info-circle" size="1x" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <preparation-modal
            v-if="detailsVisible"
            :inItem="currentItem"
            :allowEdit="!readonly"
            v-model="detailsVisible"
            @changed="changed"
            @hide="reset"
        />
    </b-container>
</template>

<script>
import _ from 'lodash';
import PreparationModal from './PreparationModal';
import DateHelper from '../../models/DateHelper';
import { loadItem, loadList } from '../../models/DataHelper';
import { IngredientRecipe } from '../../models/Recept';
import Helper from '@/models/Helper';
import { Permission } from '../../models/Permissions';

export default {
    name: 'PreparationBase',
    data: function () {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            filterOn: [],
            refresh: false,
            displayList: [],
            currentItem: null,
            readonly: false,
            detailsVisible: false,
            recipeSelected: '',
            gesloten: false,
            counter: 1,
            displayFilterCount: 20,
            strNieuw: this.$t('com_newx', {
                ns: 'common',
                val: this.$t('com_recipe', {
                    ns: 'common'
                })
            })
        };
    },
    props: {},
    components: {
        PreparationModal
    },
    computed: {
        title() {
            return this.$t('nav_mixRecept', { ns: 'nav' });
        },
        btnTekst() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_show', { ns: 'common' }),
                this.gesloten
                    ? this.$t('com_open', { ns: 'common' }).toLowerCase()
                    : this.$t('com_gesloten', {
                          ns: 'common',
                          val: ''
                      }).toLowerCase()
            );
        },
        showFilter() {
            return this.displayList
                ? this.displayList.length > this.displayFilterCount
                : false;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'naam',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_amount', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'eenheidNaam',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'bewerkingsTijd',
                    label: this.$t('com_timespan', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'bewerkingsTemperatuur',
                    label: this.$t('com_temperatuur', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'opslagduur',
                    label: this.$t('com_durationstorage', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'elementcount',
                    label: this.$t('prod_ingredienten', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            if (this.gesloten) {
                fieldsInit.push({
                    key: 'verwijderd',
                    label: this.$t('com_gesloten', { ns: 'common', val: '' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = DateHelper.convertedToDate(
                            item.verwijderd
                        );
                        return temp;
                    }
                });
            }
            return fieldsInit.filter((field) => field.visible);
        },
        magBewerken() {
            return this.currentItem
                ? this.checkRight('RecipeUpdate')
                : this.checkRight('RecipeCreate');
        }
    },
    methods: {
        flipClosed() {
            this.gesloten = !this.gesloten;
            this.reloadData();
        },
        createNewItem() {
            this.currentItem = new IngredientRecipe();
            this.recipeSelected = '';
            this.detailsVisible = true;
        },
        async editItem(item) {
            // haal item op met details
            this.readonly = false;
            this.currentItem = await loadItem(
                'preparation/loadProductionRecipe',
                { recipeid: item.id },
                this.$t
            );
            this.detailsVisible = true;
        },
        async verwijderItem(item) {
            const doClose = await this.$root.showConfirmationBox(
                this.$t('com_delete', {
                    ns: 'common',
                    val: this.$t('com_recipe', { ns: 'common' }).toLowerCase()
                }) + item.naam
            );
            if (doClose) {
                loadItem(
                    'preparation/deleteRecipe',
                    { recipeid: item.id },
                    this.$t
                );
                this.reloadData();
            }
        },
        async toonDetails(row) {
            this.readonly = true;
            this.currentItem = await loadItem(
                'preparation/loadProductionRecipe',
                { recipeid: row.id },
                this.$t
            );
            this.detailsVisible = true;
        },
        reset() {
            this.currentItem = null;
            this.detailsVisible = false;
            this.reloadData();
        },
        changed() {
            this.refresh = true;
            this.reloadData();
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async reloadData() {
            const lijst = await loadList(
                'preparation/getProductionRecipeLijst',
                'preparation/loadProductionRecipeInfo',
                null,
                this.refresh,
                this.$t
            );
            const filterLijst = this.gesloten
                ? lijst.filter((x) => x.verwijderd !== null)
                : lijst.filter((x) => x.verwijderd === null);
            this.totalRows = filterLijst ? filterLijst.length : 0;
            this.displayList = _.sortBy(filterLijst, ['naam']);
            this.refresh = false;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.displayList ? this.displayList.length : 0;
    },
    created() {
        this.refresh = true;
        const func = this.$t;
        // ToDo: haal altijd alles op, bij grote lijsten is dit niet handig!!
        loadItem('product/loadIngredientCategories', null, func).then(
            async (ingrcatArray) => {
                await Promise.all(
                    ingrcatArray.map(async (ingrcat) => {
                        ingrcat.lijst = await loadItem(
                            'product/loadIngredientInfo',
                            { category: ingrcat.naam },
                            func
                        );
                    })
                );
            }
        );
        this.reloadData();
    }
};
</script>

<style scoped></style>
